
import TrialEndedModal from '@/components/Layout/Trial/TrialEndedModal.vue'
import Tippy from '@/components/common/Tippy.vue'

export default {
    name: 'TrialCountDown',
    components: { TrialEndedModal, Tippy },
    data () {
        return {
            interval: null,
            label: '',
            modal: null
        }
    },
    computed: {
        endDate () {
            if (!this.$auth.user.sub_end_at) {
                return null
            }
            return new Date(this.$auth.user.sub_end_at)
        }
    },
    created () {
        if (!this.endDate) {
            return
        }

        this.interval = setInterval(() => {
            const now = new Date()
            const difference = this.endDate - now

            // Calculate days, hours, minutes, and seconds
            const hours = (Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + '').padStart(2, '0')
            const minutes = (Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)) + '').padStart(2, '0')
            const seconds = (Math.floor((difference % (1000 * 60)) / 1000) + '').padStart(2, '0')

            if (difference > 0) {
                this.label = `${hours} : ${minutes} : ${seconds}`
            } else {
                this.label = 'انتهت'
                this.showTrialEndedModal()
                this.clearInterval()
            }
        }, 1000)
    },
    beforeDestroy () {
        this.clearInterval()
    },
    methods: {
        showTrialEndedModal () {
            if (!this.$auth.user.last_pkg_contact) {
                this.modal = 'trial-ended'
            }
        },
        clearInterval () {
            if (this.interval) {
                clearInterval(this.interval)
            }
        }
    }
}
